'use client';
import cn from 'classnames';
import Image from 'next/image';
import Text from '@/components/common/Text/Text';

import './EllaIntroMessage.style.scss';
import EllaAiLogo from 'public/img/logo/ella-ai-tm.svg';
import EllaFlower from 'public/img/icon/ella-flower.svg';
import Info from 'public/img/icon/info.svg';
import Close from 'public/img/icon/close.svg';
import { Tooltip } from 'react-tooltip';

type EllaIntroMessageProps = {
  className?: string;
};

function EllaIntroMessage(props: EllaIntroMessageProps) {
  const { className = '' } = props;

  return (
    <div className={cn('EllaIntroMessage', className)}>
      <div className='EllaIntroMessage-content-container'>
        <Image
          className='EllaIntroMessage-flower'
          src={EllaFlower}
          width={31}
          height={29}
          alt='Ella AI symbol'
        />
        <Text
          variant='title-xxs'
          uppercase
        >
          Meet{' '}
          <Image
            className='EllaIntroMessage-logo'
            src={EllaAiLogo}
            height={17}
            alt='Ella'
            priority
          />
          , your personal stylist powered by{' '}
          <span style={{ textWrap: 'nowrap' }}>REVOLVE x Vivrelle.</span>
          <Image
            src={Info}
            alt='Info'
            width={14}
            height={14}
            data-tooltip-id='ella-intro-msg-tooltip'
            className='EllaIntroMessage-tooltip-anchor'
          />
        </Text>

        <Tooltip
          id='ella-intro-msg-tooltip'
          className='EllaIntroMessage-tooltip'
          classNameArrow='EllaIntroMessage-tooltip-arrow'
          anchorSelect='.EllaIntroMessage-tooltip-anchor'
          place='top'
          opacity={1}
        >
          <Image
            className='close'
            src={Close}
            alt=''
          />
          <Text variant='text-s'>
            Ella will help you complete your look with the perfect accessories
            from Vivrelle, paired with an outfit from REVOLVE and FWRD styled
            just for you.
            <br />
            <br />
            Select a prompt below or send a message to begin!
          </Text>
        </Tooltip>

        <div className='EllaIntroMessage-description'>
          <Text variant='text-s'>
            Ella will help you complete your look with the perfect accessories
            from Vivrelle, paired with an outfit from REVOLVE and FWRD styled
            just for you.
          </Text>
          <Text variant='text-s'>
            Select a prompt below or send a message to begin:
          </Text>
        </div>
      </div>
    </div>
  );
}

export default EllaIntroMessage;
